import { CONTACT_TYPES, TYPE_N2, TYPE_N3 } from '@/constants/constants';
import setCookie  from '@gcloud-npm/utils.common.set-cookie';
import {
  ZONES_BY_HEADER,
  PRODUCT_OFFERING_TYPES,
  IDS_AUTONOMOS,
  FTTR_ID,
  DISNEY_PARA_FICCION_ID_OLD,
  DISNEY_PARA_FICCION_ID,
  DISNEY_ADDON_ID_OLD,
  DISNEY_ADDON_ID,
  FICCION_TOTAL_CON_DISNEY_ID_OLD,
  FICCION_TOTAL_CON_DISNEY_ID,
} from '@/constants/modulesTv';
import mirrorFusion from '@/constants/mirrors.json';

export const normalizeClientInfo = (infoCliente) => {
  
  const lowerCaseConditional = (text) => {
    return text ? text.toLowerCase() : '';
  };
  const findPhone = (obj) => {
    let phone = null;
    obj.forEach((elem) => {
      if (elem.contactTypeTCOL === '1' && !phone) {
        phone = elem.value;
      }
    });
    return phone;
  };

  const findPhones = (obj) => {
    const phonesArray = [];
    obj.forEach((elem) => {
      if (elem.contactTypeTCOL === '1') {
        phonesArray.push(elem);
      }
    });
    return phonesArray;
  };

  const findSMS = (obj) => {
    const smsArray = [];
    obj.forEach((elem) => {
      if (elem.contactTypeTCOL === '2') {
        smsArray.push(elem);
      }
    });
    return smsArray;
  };

  let idParty = '';

  if (infoCliente && infoCliente.xcol) {
    const split = infoCliente.xcol.split('.');
    if (split.length > 1 && split[1]) {
      const parseo = JSON.parse(window.atob(split[1]));
      idParty = parseo && parseo.z;
    }
  }

  const clientInfo = {
    name:
      infoCliente && infoCliente.name
        ? infoCliente.name
        : '',
    firstSurname:
      infoCliente && infoCliente.firstSurname
        ? lowerCaseConditional(infoCliente.firstSurname)
        : '',
    secondSurname:
      infoCliente && infoCliente.secondSurname
        ? lowerCaseConditional(infoCliente.secondSurname)
        : '',
    docType: infoCliente && infoCliente.docType ? infoCliente.docType : '',
    docTypeText: infoCliente && infoCliente.docTypeText ? infoCliente.docTypeText : '',
    docNumber:
      infoCliente && infoCliente.docNumber ? infoCliente.docNumber : '',
    contactEmail:
      infoCliente && infoCliente.contactEmail ? infoCliente.contactEmail : null,
    accounts: infoCliente && infoCliente.accounts ? infoCliente.accounts : [],
    phone:
      infoCliente && infoCliente.additionalInfo && infoCliente.additionalInfo
        ? findPhone(infoCliente.additionalInfo)
        : '',
    xcol: infoCliente ? infoCliente.xcol : '',
    idParty,
    companyName:
      infoCliente && infoCliente.companyName
        ? lowerCaseConditional(infoCliente.companyName)
        : '',
    contactsPhones:
      infoCliente && infoCliente.additionalInfo && infoCliente.additionalInfo
        ? findPhones(infoCliente.additionalInfo)
        : [],
    contactsSMS:
      infoCliente && infoCliente.additionalInfo && infoCliente.additionalInfo
        ? findSMS(infoCliente.additionalInfo)
        : [],
    contactsAddress:
      infoCliente && infoCliente.contactAddress
        ? infoCliente.contactAddress
        : [],
    onboardingStatus:infoCliente.onboardingStatus,
    addresses: infoCliente && infoCliente.addresses,
    customerId:infoCliente.customerId
  };
  
  return clientInfo;
};

export const getEmailMPlusNormalizer = (response, productId) => {
  let emailMovistarPlusNormalized = response;
  if (Array.isArray(response) && response.length > 0) {
    [emailMovistarPlusNormalized] = response;
    emailMovistarPlusNormalized.productId = productId;
  }
  return emailMovistarPlusNormalized;
};
export const getKeyToMediumContact = (contact) => {
  let key = '';

  if (contact.contactTypeTCOL === CONTACT_TYPES.TELF.contactTypeTCOL) {
    key = 'newContactTelf';
  } else if (contact.contactTypeTCOL === CONTACT_TYPES.SMS.contactTypeTCOL) {
    key = 'newContactPhone';
  } else if (contact.contactTypeTCOL === CONTACT_TYPES.FAX.contactTypeTCOL) {
    key = 'newContactFax';
  } else if (contact.contactTypeTCOL === CONTACT_TYPES.EMAI.contactTypeTCOL) {
    key = 'newContactEmail';
  } else if (
    contact.contactTypeTCOL === CONTACT_TYPES.ADDRESS.contactTypeTCOL
  ) {
    key = 'newContactAddress';
  } else {
    throw Error('not supported contact type TCOL');
  }

  return key;
};

export const normalizeModifyContactMeans = (rawData) => {
  let modifyContactMeans = null;
  if (rawData) {
    modifyContactMeans = rawData;
  }
  return modifyContactMeans;
};

export const normalizeDocType = (
    telcoDocType,
  ) => {
    const docTypeObject = {
      docTypeCode: -1,
      docTypeText: null,
    };
  
    telcoDocType = telcoDocType.replace(/-|_/g, '');
  
    if (telcoDocType.toLowerCase() === 'nif') {
      docTypeObject.docTypeCode = 1;
      docTypeObject.docTypeText = 'NIF';
    } else if (telcoDocType.toLowerCase() === 'cif') {
      docTypeObject.docTypeCode = 2;
      docTypeObject.docTypeText = 'CIF';
    } else if (telcoDocType.toLowerCase() === 'nie') {
      docTypeObject.docTypeCode = 3;
      docTypeObject.docTypeText = 'NIE';
    } else if (
      telcoDocType.toLowerCase() === 'pasa' ||
      telcoDocType.toLowerCase() === 'pass' ||
      telcoDocType.toLowerCase() === 'pasaporte'
    ) {
      docTypeObject.docTypeCode = 4;
      docTypeObject.docTypeText = 'Pasaporte';
    }
    return docTypeObject;
  };


export const normalizeGetMyDataResponse = (clientInfo) => {
    const findContacts = (contactsForms, billingDirection) => {
      let smsContactPhone = {
        contactType: 'SMS',
        value: '',
        contactTypeTCOL: '2',
        favourite: true,
        advertisingUse: false,
        address: {
          id: '',
          locationFullAddress: '',
        },
      };
      let contactPhone;
      let contactEmail = {
        contactType: 'Correo Electrónico',
        value: '',
        contactTypeTCOL: '4',
        favourite: true,
        advertisingUse: false,
        address: {
          id: '',
          locationFullAddress: '',
        },
      };
  
      let billingDirectionId = '';
      let billingDirectionFullAddress = '';
      if (billingDirection) {
        const { id, locationFullAddress } = billingDirection;
        billingDirectionId = id;
        billingDirectionFullAddress = locationFullAddress;
      }
      const contactAddress = {
        contactId: billingDirectionId,
        value: billingDirectionFullAddress,
      };
      let hasFavoriteSmsContactPhone = false;
      if(contactsForms){

        contactsForms.forEach((elem) => {
          const { contactTypeTCOL, favourite } = elem;
          if (contactTypeTCOL === '1' && favourite) {
            contactPhone = elem;
          } else if (contactTypeTCOL === '2' && favourite) {
            smsContactPhone = elem;
            hasFavoriteSmsContactPhone = true;
          } else if (contactTypeTCOL === '4') {
            if (favourite) {
              contactEmail = elem;
            } else if (!contactEmail.value) {
              contactEmail = elem;
            }
          } else if (contactTypeTCOL === '5' && favourite) {
            contactAddress.contactId = elem.address.id;
            contactAddress.value = elem.address.locationFullAddress;
          }
        });
      }
  
      const contacts = {
        contactPhone: hasFavoriteSmsContactPhone
          ? smsContactPhone
          : contactPhone || smsContactPhone,
        contactEmail,
        contactAddress,
      };
  
      return contacts;
    };
  
    const normalizeCustomerAccounts = (customerAccounts) => {
      let accounts = '';
      if (customerAccounts) {
        accounts = customerAccounts.map((elem) => {
          return {
            customerAccount: elem.spanishIbanAccountNumber,
            customerAccountName: elem.customerAccountName,
            customerAccountId: elem.customerAccountId,
          };
        });
      }
      return accounts;
    };

    const normalizeBillAddresses = ({ permanentResidence, customerAccounts }) => {
      let addresses = [];
      if (permanentResidence && permanentResidence.locationFullAddress) {
        addresses.push({ id: permanentResidence.id, address: permanentResidence.locationFullAddress, show: true, type: TYPE_N2 })
      }
      if (customerAccounts && Array.isArray(customerAccounts) && customerAccounts.length > 0) {
        customerAccounts.forEach((item) => {
          if (item.address && item.address.mostrarDireccion && item.address.mostrarDireccion === true) {
            const { customerAccountId } = item;
            const { id, locationFullAddress, mostrarDireccion } = item.address;
            const idFound = addresses.find(obj => obj.id === id);
            if (!idFound) {
              addresses.push({ id: id, address: locationFullAddress, show: mostrarDireccion, accountId: customerAccountId, type: TYPE_N3 })
            } else {
              idFound.accountId = customerAccountId;
            }
          }
        })
      }
      return addresses;
    }

    const {
      xcol,
      contactsForms,
      permanentResidence: billingDirection,
      name,
      firstSurName,
      secondSurName,
      companyName,
      documentType,
      numberDocument,
      customerAccounts,
      customerId,
      onboardingStatus
    } = clientInfo;

  
    if (xcol) {
      setCookie('XCOL', xcol, 1, '.movistar.es', false);
    }
    const { contactEmail, contactPhone, contactAddress } = findContacts(
      contactsForms,
      billingDirection,
    );
  
    const { docTypeCode, docTypeText } = normalizeDocType(documentType);
   
    const normalizedClientInfo = {
      customerId,
      name,
      firstSurname: firstSurName,
      secondSurname: secondSurName,
      companyName,
      docType: docTypeCode,
      docTypeText,
      docNumber: numberDocument,
      contactEmail,
      contactPhone,
      contactAddress,
      accounts: normalizeCustomerAccounts(customerAccounts),
      additionalInfo: contactsForms,
      xcol,
      onboardingStatus: onboardingStatus,
      addresses: normalizeBillAddresses({ permanentResidence: billingDirection, customerAccounts})
    };

    return normalizedClientInfo;
  };

  // Funcion normalizadora del user para la llamada del init de tv
const getMirrorFusionProducts = (fusionPo, additionalPos) => {
  let mirrorFusionProducts = [];

  const { fusiones, addons } = mirrorFusion || {};

  if (fusionPo && fusiones && fusiones[fusionPo]) {
    mirrorFusionProducts = fusiones[fusionPo];
  }

  if (addons && additionalPos && Array.isArray(additionalPos) && additionalPos.length > 0) {
    additionalPos.forEach((additionalPo) => {
      if (
        addons[additionalPo.id]
        && Array.isArray(addons[additionalPo.id])
        && addons[additionalPo.id].length > 0
      ) {
        addons[additionalPo.id].forEach((addon) => {
          mirrorFusionProducts.push(addon);
        });
      }
    })
  }
  return mirrorFusionProducts;
}

const normalizeCampaignsRedeemed = (customer) => {
  const campaignsRedeemed = [];
  if (
    customer
    && customer.campaigns
    && customer.campaigns.redeemed
    && Array.isArray(customer.campaigns.redeemed)
    && customer.campaigns.redeemed.length > 0
  ) {
    customer.campaigns.redeemed.forEach(({ campaignId }) => {
      campaignsRedeemed.push(campaignId);
    })
  }
  return campaignsRedeemed;
}

const normalizeUserCompatibilities = (userCompatibilities) => {
  const userCompatibilitiesNormalized = {};

  // phoneNumbers
  if (
    userCompatibilities
    && userCompatibilities.lm
    && userCompatibilities.lm.mobileLineActions
    && userCompatibilities.lm.mobileLineActions.migra
    && userCompatibilities.lm.mobileLineActions.migra.INCOMPATIBLE
    && Array.isArray(userCompatibilities.lm.mobileLineActions.migra.INCOMPATIBLE)
    && userCompatibilities.lm.mobileLineActions.migra.INCOMPATIBLE.length > 0
  ) {
    userCompatibilitiesNormalized.phoneNumbers = [];
    userCompatibilities.lm.mobileLineActions.migra.INCOMPATIBLE.forEach(({ mobileLineNumber }) => {
      userCompatibilitiesNormalized.phoneNumbers.push(mobileLineNumber);
    });
  }

  // R2R
  if (
    userCompatibilities
    && userCompatibilities.r2r
    && userCompatibilities.r2r.hiredR2R
    && Array.isArray(userCompatibilities.r2r.hiredR2R)
    && userCompatibilities.r2r.hiredR2R.length > 0
  ) {
    userCompatibilitiesNormalized.r2r = [];
    userCompatibilities.r2r.hiredR2R.forEach(({ productOfferingId, productName }) => {
      userCompatibilitiesNormalized.r2r.push({
        productOfferingId,
        productName,
      });
    });
  }
  return userCompatibilitiesNormalized;
}

 export const normalizeUserBundle = (mainInfo) => {
  const clienteInfoBundle = [];
  const {
    userBundle, customer, userPq, userPo, userCompatibilities,
  } = mainInfo || {};

  const { phoneNumbers, r2r } = normalizeUserCompatibilities(userCompatibilities);

  const clientInfo = {
    bundleId: null,
    bundleModules: [],
    productId: null,
    productType: null,
    fttr: null,
    conexion: [],
    tv: [],
    oldTv: [],
    mobile: [],
    productPromotions: [],
    campaignsRedeemed: normalizeCampaignsRedeemed(customer),
    phoneNumbers,
    r2r,
    productCategory: userPq?.cfi,
    productZoneId: ZONES_BY_HEADER.FREE,
    additionalProductIds: [],
  };

  let userBundleProducts = [];
  if (userBundle && typeof userBundle === 'object') {
    userBundleProducts = Object.values(userBundle);
  }

  userBundleProducts.forEach((userBundleProduct) => {
    const {
      poId,
      productId,
      mainZone,
      pot,
      tv,
      mobile,
      promotions,
    } = userBundleProduct || {};

    if (IDS_AUTONOMOS.includes(poId)) {
      clientInfo.isAutonomo = true;
    }

    if (pot.some(
      (element) => element.id === PRODUCT_OFFERING_TYPES.PRODUCTS.MIMOVISTAR.ID,
    )) {
      // si encuentro un mimo siempre actualizo la info
      const bundleModules = userPo?.PACK_MODULES?.split('||').map((part) => part.replace(/---/g, '').trim()).filter(Boolean) || [];

      clientInfo.bundleId = poId;
      clientInfo.bundleModules = bundleModules;
      clientInfo.conexion = bundleModules.filter(
        (bundleModule) => bundleModule.startsWith('10'),
      );
      clientInfo.productId = productId;
      if (mainZone) {
        clientInfo.productZoneId = mainZone;
      }
      clientInfo.productType = PRODUCT_OFFERING_TYPES.PRODUCTS.MIMOVISTAR.ID;
    }
    if (!clientInfo.productType) {
      // si no tengo info todavia la relleno
      // y solo si es del type que busco relleno el productType
      clientInfo.bundleId = poId;
      clientInfo.productId = productId;
      if (mainZone) {
        clientInfo.productZoneId = mainZone;
      }
      if (pot.some(
        (element) => element.id === PRODUCT_OFFERING_TYPES.PRODUCTS.FUSION.ID,
      )) {
        clientInfo.productType = PRODUCT_OFFERING_TYPES.PRODUCTS.FUSION.ID;
      } else if (pot.some(
        (element) => element.id === PRODUCT_OFFERING_TYPES.PRODUCTS.BAF.ID,
      )) {
        clientInfo.productType = PRODUCT_OFFERING_TYPES.PRODUCTS.BAF.ID;
      }
    }

    // FTTR
    if (poId === FTTR_ID) {
      clientInfo.fttr = poId;
    }

    // TV
    if (tv) {
      const tvKeys = Object.keys(tv);
      if (tvKeys && Array.isArray(tvKeys) && tvKeys.length > 0) {
        tvKeys.forEach((tvKey) => {
          const { pcd } = tv[tvKey];
          if (pcd) {
            const pcdValues = Object.values(pcd);
            if (pcdValues && Array.isArray(pcdValues) && pcdValues.length > 0) {
              pcdValues.forEach(({
                poId: tvPoId,
                bundleId: id,
                characs,
                productId: tvProductId,
                promotions: tvPromotions,
              }) => {
                if (tvProductId) {
                  clientInfo.additionalProductIds.push({
                    id: tvPoId || id,
                    productId: tvProductId,
                  });
                }
                if (
                  id
                  && characs
                  && Array.isArray(characs)
                  && characs.length > 0
                  && characs[0]
                  && characs[0].id === '43'
                ) {
                  const { id: characsId, valueId } = characs[0];
                  clientInfo.netflix = {
                    id,
                    characteristics: [{
                      id: characsId,
                      value: valueId,
                    }],
                  }
                } else if (tvPoId) {
                  // Convertir poIds antiguos por actuales
                  if (tvPoId === DISNEY_PARA_FICCION_ID_OLD) {
                    clientInfo.tv.push(DISNEY_PARA_FICCION_ID);
                    clientInfo.oldTv.push({
                      id: DISNEY_PARA_FICCION_ID,
                      oldId: tvPoId,
                    });
                  } else if (tvPoId === DISNEY_ADDON_ID_OLD) {
                    clientInfo.tv.push(DISNEY_ADDON_ID);
                    clientInfo.oldTv.push({
                      id: DISNEY_ADDON_ID,
                      oldId: tvPoId,
                    });
                  } else if (tvPoId === FICCION_TOTAL_CON_DISNEY_ID_OLD) {
                    clientInfo.tv.push(FICCION_TOTAL_CON_DISNEY_ID);
                    clientInfo.oldTv.push({
                      id: FICCION_TOTAL_CON_DISNEY_ID,
                      oldId: tvPoId,
                    });
                  } else {
                    clientInfo.tv.push(tvPoId);
                  }
                }
                if (tvPromotions && Array.isArray(tvPromotions) && tvPromotions.length > 0) {
                  tvPromotions.forEach(({ id: tvPromotionId }) => {
                    clientInfo.productPromotions.push({ id: tvPromotionId });
                  })
                }
              })
            }
          }
        })
      }
    }

    // MOBILE
    if (mobile) {
      const mobileKeys = Object.keys(mobile);
      if (mobileKeys && mobileKeys.length > 0) {
        mobileKeys.forEach((mobileKey) => {
          const { pcd } = mobile[mobileKey];
          if (pcd && Array.isArray(pcd) && pcd.length > 0) {
            const mobilePcdValues = Object.values(pcd);
            if (mobilePcdValues && Array.isArray(mobilePcdValues) && mobilePcdValues.length > 0) {
              mobilePcdValues.forEach(({ poId: mobilePoId }) => {
                if (mobilePoId) {
                  clientInfo.mobile.push(mobilePoId);
                }
              })
            }
          }
        })
      }
    }
    let fusionEquivalentes = null;
    if (clientInfo.productType === PRODUCT_OFFERING_TYPES.PRODUCTS.FUSION.ID) {
      fusionEquivalentes = getMirrorFusionProducts(clientInfo.bundleId, clientInfo.tv);
    }
    if (fusionEquivalentes) {
      clientInfo.mirrorFusionModules = fusionEquivalentes;
    }

    if (
      promotions
      && Array.isArray(promotions)
      && promotions.length > 0
    ) {
      promotions.forEach(({ id }) => {
        clientInfo.productPromotions.push({ id });
      })
    }
    clienteInfoBundle.push(clientInfo)
  });

  return { clienteInfoBundle };
}